import StorageHelper from '@/utils/storageHelper';
import { JourneyAction } from '@/services/Api/index';
import { JOURNEY_ITEM_TYPE, ACTION_TYPE } from '@/constants/journey.constants.js';

const sendLog = (journeyItemIds, journeyItemType, actionType) => {
  JourneyAction.journeyActionLog({
    journeyItemIds,
    journeyItemType,
    actionType,
  }).catch(error => {
    console.error(
      `Error logging banner ${
        actionType === ACTION_TYPE.CLICK ? 'click' : actionType === ACTION_TYPE.VIEW ? 'view' : ''
      }:`,
      error,
    );
  });
};

export const logJourneyAction = (customerCode, bannerIds, journeyItemType, actionType, logType) => {
  switch (journeyItemType) {
    case JOURNEY_ITEM_TYPE.MAIN_BANNER:
    case JOURNEY_ITEM_TYPE.SUB_BANNER: {
      const storageBannerHelper = new StorageHelper({
        id: logType,
      });

      const currentUser = new StorageHelper({
        id: process.env.VUE_APP_STORAGE_CURRENT_USER_KEY,
      }).get();

      const twelveHoursInMillis = 12 * 60 * 60 * 1000;
      const isValid = storageBannerHelper.isValid(twelveHoursInMillis);

      // If 12 hours have passed
      if (isValid) {
        storageBannerHelper.remove();
      }

      const storageBanners = storageBannerHelper.get() || [];

      const user = storageBanners.find(
        user => user.customerCode === customerCode && user.userId === currentUser.id,
      );

      if (user) {
        const newBannerIds = bannerIds.filter(id => !user.bannerIds.includes(id));
        user.bannerIds.push(...newBannerIds);
        if (newBannerIds.length > 0) {
          storageBannerHelper.set(storageBanners);
          sendLog(newBannerIds, journeyItemType, actionType);
        }
      } else {
        storageBannerHelper.set([
          ...storageBanners,
          {
            customerCode,
            userId: currentUser.id,
            bannerIds,
          },
        ]);
        bannerIds.length > 0 && sendLog(bannerIds, journeyItemType, actionType);
      }
      break;
    }

    case JOURNEY_ITEM_TYPE.POPUP:
      sendLog(bannerIds, journeyItemType, actionType);
      break;

    default:
      break;
  }
};
